import { PropsWithChildren, useContext } from 'react';
import { ActiveRolePermissionContext } from '@taleemabad/providers';
import {
  AbilityContext,
  buildAbilityFromAccessControls,
} from '@taleemabad/shared';

export const AbilityContextProvider = ({ children }: PropsWithChildren) => {
  const { activeRolePermission, features } = useContext(
    ActiveRolePermissionContext,
  );
  const ability = buildAbilityFromAccessControls(
    activeRolePermission?.accessControls ?? [],
    features,
  );

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};
